import React from 'react';

// Internal Variable Context
const cmVariableContext =
  typeof window !== 'undefined' ? require('@readme/syntax-highlighter/dist').cmVariableContext : React.createContext();

const PermissionContext = React.createContext(false);
export { cmVariableContext, PermissionContext };
